import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Consolidated AssistantIcon (formerly duplicated in src/components/ and here).
// Union of both APIs: `enclosed` (circular badge) + `margin`.
//
// Color is applied via a STATIC classNames map, not a `sui-fill-${color}`
// template literal, so Harmony's prebuild can statically extract the utility
// classes. To support a new color, add its static `sui-fill-*` class here.
const fillClass = (color) => classNames({
  'sui-fill-brand': color === 'brand',
  'sui-fill-inverse': color === 'inverse',
});

const icon = ({ color, height, width, margin }) => (
  <svg
    className={fillClass(color)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 52"
    height={height}
    width={width}
    fill="none"
    role="presentation"
    style={{ minWidth: width, margin }}
    data-component="AssistantIcon"
  >
    <g>
      {/* eslint-disable-next-line max-len */}
      <path d="M22.5 0L0 13.0007V38.9993L22.5 52L45 38.9993V13.0007L22.5 0ZM42.2658 32.3577L30.479 43.7441L41.961 28.7683L42.0281 28.6816L42.2658 29.6383V32.3577ZM26.8781 46.3068L11.1298 41.7858L29.9394 44.2645L29.2321 44.9499L26.8781 46.3096V46.3068ZM7.11233 39.9477L3.15078 24.0374L10.4113 41.5787L9.46633 41.3074L7.11233 39.9477ZM2.73422 19.6395L14.521 8.25308L3.03895 23.2289L2.97185 23.3157L2.73422 22.3617V19.6395ZM18.1219 5.69043L33.8702 10.2114L15.0606 7.73272L15.7679 7.05009L18.1219 5.69043ZM37.8849 12.0495L41.8464 27.9598L34.5859 10.4185L35.5309 10.6898L37.8849 12.0495ZM11.7476 17.0461L24.8736 12.2062L35.6259 21.1615L33.2524 34.9567L20.1264 39.7966L9.37407 30.8441L11.7476 17.0489V17.0461ZM8.62481 30.3518L7.10394 28.4829L10.4672 19.6423L8.62481 30.3518ZM36.3724 21.6455L37.8933 23.5143L34.53 32.3549L36.3724 21.6455ZM38.5503 24.099L39.5511 25.786L34.4322 34.9175L38.5475 24.099H38.5503ZM31.5749 10.7374L33.9597 11.0507L39.0227 23.2849L31.5749 10.7374ZM36.1879 20.1151L28.8826 11.1375L30.8452 11.1123L36.1879 20.1151ZM34.0184 18.7499L25.6703 11.7977L28.0495 11.4144L34.0184 18.7499ZM13.8305 10.5052L15.2954 8.59439L28.413 10.3233L13.8305 10.5052ZM24.2501 11.1962L12.8296 13.0399L13.7885 11.3277L24.2501 11.1962ZM21.9856 12.3936L11.7952 16.1509L12.6535 13.8987L21.9856 12.3936ZM4.75553 25.7636L3.83574 23.5395L11.8902 13.0343L4.75553 25.7636ZM10.565 17.0797L6.44974 27.8982L5.44887 26.2112L10.5678 17.0797H10.565ZM13.4251 41.257L11.0403 40.9437L5.97726 28.7095L13.4251 41.257ZM8.81212 31.8821L16.1174 40.8597L14.1548 40.8849L8.81212 31.8849V31.8821ZM10.9816 33.2473L19.3296 40.1995L16.9505 40.5828L10.9816 33.2473ZM31.1695 41.492L29.7046 43.4028L16.5842 41.6739L31.1667 41.492H31.1695ZM20.7499 40.801L32.1704 38.9573L31.2115 40.6695L20.7499 40.801ZM23.0144 39.6036L33.2048 35.8435L32.3465 38.0957L23.0144 39.6008V39.6036ZM40.2445 26.2336L41.1643 28.4577L33.1098 38.9629L40.2445 26.2336ZM42.2658 26.2392L38.8746 12.6202L40.306 13.4455L42.2658 25.9119V26.2392ZM32.5898 8.99166L19.1088 5.11971L20.5374 4.2944L32.3046 8.8266L32.587 8.99166H32.5898ZM12.8268 8.75106L2.73701 18.4981V16.8475L12.5444 8.91612L12.8268 8.75386V8.75106ZM2.73422 25.758L6.12543 39.3742L4.69682 38.5489L2.73701 26.0853V25.758H2.73422ZM12.4102 43.0055L25.8912 46.8775L24.4626 47.7028L12.6954 43.1706L12.413 43.0083L12.4102 43.0055ZM32.1732 43.2461L42.263 33.4991V35.1525L32.4556 43.0839L32.1732 43.2461ZM42.2658 20.6299L41.2202 13.9771L42.2658 14.5814V20.6299ZM27.7336 6.18561L21.4544 3.76564L22.5 3.16135L27.7336 6.18561ZM7.97061 11.5543L2.73701 15.7872V14.5786L7.97061 11.5543ZM2.73422 31.3701L3.77982 38.0229L2.73422 37.4186V31.3701ZM17.2664 45.8116L23.5484 48.2316L22.5028 48.8359L17.2692 45.8116H17.2664ZM37.0294 40.4429L42.263 36.21V37.4186L37.0294 40.4429Z" />
    </g>
  </svg>
);

// TODO: find way to make icon svg size programatically defined so we can use only one prop for size
export const AssistantIcon = ({
  color = 'brand',
  height = '24px',
  width = '22px',
  enclosed = false,
  margin,
}) => {
  const enclosureStyle = classNames(
    'sui-flex sui-justify-center sui-items-center',
    'sui-border-solid sui-border-1 sui-rounded-full sui-border-accent',
    {
      'sui-w-14 sui-h-14': height === '32px',
      'sui-w-11 sui-h-11': height === '24px',
      'sui-w-8 sui-h-8': height === '18px',
    }
  );
  return enclosed ? (
    <div className={enclosureStyle}>
      {icon({ color, height, width, margin })}
    </div>
  ) : (
    icon({ color, height, width, margin })
  );
};

AssistantIcon.displayName = 'AssistantIcon';

AssistantIcon.propTypes = {
  color: PropTypes.oneOf(['brand', 'inverse']),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  enclosed: PropTypes.bool,
  margin: PropTypes.string,
};
